import React from "react";

import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IntlShape } from "react-intl";

import { Group } from "@mapmycustomers/shared/types/entity";
import BulkApiError from "@mapmycustomers/shared/util/api/BulkApiError";
import { showModal } from "@mapmycustomers/ui";

import getErrorMessageByCode from "@app/util/errorHandling/platformErrorCodes";

import styles from "./BulkActions.module.scss";
import messages from "./messages";

const showBulkDeleteErrorModal = (
  intl: IntlShape,
  groups: Group[],
  validationErrors: BulkApiError[]
) => {
  const groupsMap = new Map(groups.map((group) => [group.id, group]));

  const erroredGroups = validationErrors
    .filter(({ id, errors }) => errors.length && groupsMap.has(id))
    .map((error) => {
      const group = groupsMap.get(error.id)!;
      return {
        id: error.id,
        message: getErrorMessageByCode(intl, error.errors[0].code) ?? error.errors[0].message,
        name: group.name,
      };
    });

  showModal({
    cancelButtonProps: { hidden: true },
    centered: true,
    className: styles.modal,
    closable: true,
    content: (
      <div className={styles.content}>
        <FontAwesomeIcon className={styles.errorIcon} icon={faTriangleExclamation} />
        <span className={styles.title}>
          {intl.formatMessage(messages.errorTitle, { count: groups.length })}
        </span>
        <span className={styles.description}>
          {intl.formatMessage(messages.errorDescription, { count: groups.length })}
        </span>
        <div className={styles.groups}>
          {erroredGroups.map(({ id, message, name }) => (
            <div key={id}>
              <div className={styles.groupName}>{name}</div>
              <div>{message}</div>
            </div>
          ))}
        </div>
      </div>
    ),
    icon: null,
    okText: intl.formatMessage(messages.okText),
    title: intl.formatMessage(messages.modalTitle, { count: groups.length }),
    type: "error",
    width: "548px",
  });
};

export default showBulkDeleteErrorModal;
